import React from 'react';
export function StatsBar() {
  const stats = [{
    value: '+800',
    label: 'familias confían'
  }, {
    value: '6',
    label: 'Tomos completos'
  }, {
    value: '4.9/5',
    label: 'calificación ⭐'
  }, {
    value: '6',
    label: 'Bonos incluidos'
  }];
  return <div className="bg-navy-900/80 border-y border-navy-700/50 py-6 relative z-20 backdrop-blur-sm" data-id="element-269">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-270">
        <div className="grid grid-cols-2 gap-4 md:grid-cols-4 md:gap-0 md:divide-x md:divide-navy-700/60" data-id="element-271">
          {stats.map((stat, index) => <div key={index} className="flex items-center gap-2.5 justify-center md:px-4 hero-animate-4" data-id="element-272">
              <span className="text-xl md:text-3xl font-bold font-poppins text-transparent bg-clip-text bg-gradient-to-r from-white to-slate-300" data-id="element-273">
                {stat.value}
              </span>
              <span className="text-[11px] md:text-sm text-slate-400 font-medium leading-tight max-w-[90px]" data-id="element-274">
                {stat.label}
              </span>
            </div>)}
        </div>
      </div>
    </div>;
}